// Vehicle make → model catalog used by the "Register New Vehicle" form.
export const carCatalog = [
  // ==========================================
  // ORIGINAL CATALOG (15 brands)
  // ==========================================
  { make: "Toyota", models: ["Camry", "Corolla", "Avalon", "RAV4", "Highlander", "Prado", "Land Cruiser", "Hilux", "Sienna", "Venza", "Yaris", "4Runner", "bZ4X"] },
  { make: "Honda", models: ["Accord", "Civic", "CR-V", "HR-V", "Pilot", "Odyssey", "Prologue", "e:Ny1"] },
  { make: "Mercedes-Benz", models: ["C-Class", "E-Class", "S-Class", "GLA", "GLK", "GLC", "GLE", "GLS", "EQA", "EQB", "EQE", "EQS"] },
  { make: "BMW", models: ["3 Series", "5 Series", "7 Series", "X1", "X3", "X5", "X6", "i4", "i5", "i7", "iX", "iX3"] },
  { make: "Lexus", models: ["ES", "IS", "LS", "RX", "NX", "GX", "LX", "RZ 450e"] },
  { make: "Audi", models: ["A3", "A4", "A6", "Q3", "Q5", "Q7", "e-tron GT", "Q4 e-tron", "Q8 e-tron"] },
  { make: "Hyundai", models: ["Elantra", "Sonata", "Tucson", "Santa Fe", "Ioniq 5", "Ioniq 6", "Kona Electric"] },
  { make: "Kia", models: ["Rio", "Cerato", "Optima", "Sportage", "Sorento", "EV6", "EV9", "Niro EV"] },
  { make: "Nissan", models: ["Altima", "Sentra", "Maxima", "Rogue", "Pathfinder", "Patrol", "Leaf", "Ariya"] },
  { make: "Volkswagen", models: ["Golf", "Jetta", "Passat", "Tiguan", "ID.3", "ID.4", "ID. Buzz"] },
  { make: "Ford", models: ["Focus", "Fusion", "Escape", "Explorer", "Edge", "F-150", "Mustang Mach-E", "F-150 Lightning"] },
  { make: "Chevrolet", models: ["Malibu", "Impala", "Tahoe", "Suburban", "Bolt EV", "Equinox EV", "Blazer EV"] },
  { make: "Range Rover", models: ["Evoque", "Velar", "Sport", "Vogue"] },
  { make: "Jeep", models: ["Wrangler", "Cherokee", "Grand Cherokee"] },
  { make: "Peugeot", models: ["206", "207", "301", "307", "308", "5008"] },

  // ==========================================
  // FIRST EXPANSION (50 brands)
  // ==========================================
  { make: "Acura", models: ["MDX", "RDX", "TLX", "ILX", "Integra"] },
  { make: "Alfa Romeo", models: ["Giulia", "Stelvio", "Tonale", "4C", "Giulietta"] },
  { make: "Aston Martin", models: ["DB11", "DB12", "DBS", "Vantage", "DBX"] },
  { make: "Bentley", models: ["Continental GT", "Flying Spur", "Bentayga", "Mulsanne"] },
  { make: "Bugatti", models: ["Veyron", "Chiron", "Divo", "Tourbillon"] },
  { make: "Buick", models: ["Enclave", "Encore", "Envision", "LaCrosse", "Regal"] },
  { make: "BYD", models: ["Atto 3", "Seal", "Dolphin", "Han", "Tang", "Song Plus", "Seagull", "Sealion 7"] },
  { make: "Cadillac", models: ["Escalade", "CT4", "CT5", "XT4", "XT5", "XT6", "Lyriq"] },
  { make: "Changan", models: ["CS35 Plus", "CS55 Plus", "CS75 Plus", "CS85", "CS95", "UNI-K", "UNI-V"] },
  { make: "Chery", models: ["Tiggo 2", "Tiggo 4 Pro", "Tiggo 7 Pro", "Tiggo 8 Pro", "Arrizo 8"] },
  { make: "Chrysler", models: ["300", "Pacifica", "Voyager", "Town & Country"] },
  { make: "Citroën", models: ["C3", "C4", "C5 Aircross", "Berlingo"] },
  { make: "Cupra", models: ["Formentor", "Born", "Leon", "Ateca", "Tavascan"] },
  { make: "Dacia", models: ["Duster", "Sandero", "Jogger", "Spring", "Logan"] },
  { make: "Daihatsu", models: ["Terios", "Sirion", "Mira", "Move", "Tanto"] },
  { make: "Dodge", models: ["Charger", "Challenger", "Durango", "Hornet", "Journey"] },
  { make: "Ferrari", models: ["296 GTB", "SF90 Stradale", "F8 Tributo", "Roma", "Purosangue", "812 Superfast"] },
  { make: "Fiat", models: ["500", "500X", "Panda", "Tipo", "Punto"] },
  { make: "GAC Motor", models: ["GS3", "GS4", "GS8", "GN8", "Empow"] },
  { make: "Geely", models: ["Coolray", "Azkarra", "Monjaro", "Emgrand", "Tugella", "Galaxy L7", "Galaxy E8"] },
  { make: "Genesis", models: ["G70", "G80", "G90", "GV70", "GV80", "GV60"] },
  { make: "GMC", models: ["Sierra 1500", "Yukon", "Acadia", "Terrain", "Canyon", "Hummer EV"] },
  { make: "Great Wall Motor", models: ["Poer", "Wingle 5", "Wingle 7", "Cannon"] },
  { make: "Haval", models: ["H6", "Jolion", "Dargo", "H9"] },
  { make: "Infiniti", models: ["Q50", "Q60", "QX50", "QX55", "QX60", "QX80"] },
  { make: "Isuzu", models: ["D-Max", "MU-X", "Trooper"] },
  { make: "Jaguar", models: ["XE", "XF", "XJ", "F-Pace", "E-Pace", "I-Pace", "F-Type"] },
  { make: "Koenigsegg", models: ["Jesko", "Gemera", "Regera", "Agera"] },
  { make: "Lamborghini", models: ["Huracán", "Aventador", "Urus", "Revuelto", "Temerario"] },
  { make: "Lancia", models: ["Ypsilon", "Delta", "Thema"] },
  { make: "Land Rover", models: ["Defender", "Discovery", "Discovery Sport", "Freelander"] },
  { make: "Lincoln", models: ["Navigator", "Aviator", "Nautilus", "Corsair", "Continental"] },
  { make: "Lotus", models: ["Emira", "Eletre", "Evora", "Exige", "Elise", "Emeya"] },
  { make: "Lucid", models: ["Air Pure", "Air Touring", "Air Grand Touring", "Air Sapphire", "Gravity", "Air"] },
  { make: "Maserati", models: ["Ghibli", "Quattroporte", "Levante", "Grecale", "MC20"] },
  { make: "Mazda", models: ["Mazda3", "Mazda6", "CX-30", "CX-5", "CX-50", "CX-90", "MX-5 Miata"] },
  { make: "McLaren", models: ["720S", "750S", "Artura", "GT", "570S"] },
  { make: "MG", models: ["MG3", "MG4 EV", "MG5", "MG ZS", "MG HS", "Cyberster", "MG ZS EV"] },
  { make: "Mini", models: ["Cooper", "Clubman", "Countryman", "Aceman"] },
  { make: "Mitsubishi", models: ["Lancer", "Outlander", "Pajero", "ASX", "Eclipse Cross", "L200"] },
  { make: "NIO", models: ["ET5", "ET7", "ET9", "ES6", "ES7", "ES8", "EC6", "EC7"] },
  { make: "Opel", models: ["Corsa", "Astra", "Mokka", "Crossland", "Grandland", "Insignia"] },
  { make: "Pagani", models: ["Zonda", "Huayra", "Utopia"] },
  { make: "Polestar", models: ["Polestar 2", "Polestar 3", "Polestar 4"] },
  { make: "Pontiac", models: ["G6", "G8", "Grand Prix", "Firebird", "Vibe", "Solstice"] },
  { make: "Porsche", models: ["911", "718 Cayman", "718 Boxster", "Panamera", "Macan", "Cayenne", "Taycan", "Macan Electric"] },
  { make: "RAM", models: ["1500", "2500", "3500", "ProMaster", "Rampage"] },
  { make: "Renault", models: ["Clio", "Megane", "Captur", "Kadjar", "Koleos", "Duster", "5 E-Tech"] },
  { make: "Rivian", models: ["R1T", "R1S", "R2", "R3", "R3X"] },
  { make: "Rolls-Royce", models: ["Phantom", "Ghost", "Cullinan", "Wraith", "Dawn", "Spectre"] },
  { make: "Saab", models: ["9-3", "9-5", "900", "9-4X"] },
  { make: "Scion", models: ["tC", "xB", "xD", "FR-S", "iA", "iM"] },
  { make: "SEAT", models: ["Ibiza", "Leon", "Arona", "Ateca", "Tarraco"] },
  { make: "Škoda", models: ["Fabia", "Octavia", "Superb", "Kamiq", "Karoq", "Kodiaq", "Enyaq"] },
  { make: "Smart", models: ["Fortwo", "Forfour", "#1", "#3", "#5"] },
  { make: "SsangYong", models: ["Tivoli", "Korando", "Rexton", "Musso", "Torres"] },
  { make: "Subaru", models: ["Impreza", "Legacy", "Crosstrek", "Forester", "Outback", "WRX", "BRZ", "Solterra"] },
  { make: "Suzuki", models: ["Swift", "Baleno", "Vitara", "Grand Vitara", "Jimny", "Ciaz", "Ertiga"] },
  { make: "Tata", models: ["Nexon", "Harrier", "Safari", "Punch", "Tiago", "Altroz", "Curvv"] },
  { make: "Tesla", models: ["Model 3", "Model S", "Model X", "Model Y", "Cybertruck"] },
  { make: "Vauxhall", models: ["Corsa", "Astra", "Mokka", "Crossland", "Grandland"] },
  { make: "VinFast", models: ["VF 3", "VF 5", "VF 6", "VF 7", "VF 8", "VF 9"] },
  { make: "Volvo", models: ["S60", "S90", "V60", "V90", "XC40", "XC60", "XC90", "EX30", "EX90", "C40 Recharge"] },
  { make: "XPENG", models: ["P7", "P7+", "P5", "G6", "G9", "X9", "Mona M03"] },
  { make: "Zeekr", models: ["001", "007", "009", "X", "7X", "Mix"] },

  // ==========================================
  // 100 NEW BRANDS (HEAVILY FEATURING CHINESE EVS)
  // ==========================================
  // --- New Chinese EV & New-Energy Makes ---
  { make: "Xiaomi", models: ["SU7", "SU7 Pro", "SU7 Max", "SU7 Ultra", "YU7"] },
  { make: "Li Auto", models: ["L6", "L7", "L8", "L9", "Mega"] },
  { make: "AITO", models: ["M5", "M7", "M9"] },
  { make: "Avatr", models: ["11", "12", "07"] },
  { make: "Deepal", models: ["SL03", "S05", "S07", "L07", "G318"] },
  { make: "Leapmotor", models: ["T03", "C01", "C10", "C11", "C16", "B10"] },
  { make: "Yangwang", models: ["U7", "U8", "U9"] },
  { make: "Fangchengbao", models: ["Bao 3", "Bao 5", "Bao 8", "Super 9"] },
  { make: "Denza", models: ["D9", "N7", "N8", "Z9", "Z9 GT"] },
  { make: "IM Motors", models: ["L6", "L7", "LS6", "LS7"] },
  { make: "Onvo", models: ["L60"] },
  { make: "Firefly", models: ["Firefly Hatchback"] },
  { make: "GAC Aion", models: ["Aion S", "Aion S Plus", "Aion Y Plus", "Aion V", "Aion LX"] },
  { make: "Hyptec", models: ["SSR", "GT", "HT"] },
  { make: "Jiyue", models: ["01", "07"] },
  { make: "Lynk & Co", models: ["01", "02", "03", "05", "06", "07 EM-P", "08 EM-P", "09", "Z10"] },
  { make: "Ora", models: ["Good Cat", "Funky Cat", "Ballet Cat", "Lightning Cat"] },
  { make: "Tank", models: ["Tank 300", "Tank 400", "Tank 500", "Tank 700", "Tank 800"] },
  { make: "Wey", models: ["Mocha", "Coffee 01", "Coffee 02", "Latte", "Macchiato", "Blue Mountain", "Gaoshan"] },
  { make: "Voyah", models: ["Free", "Dreamer", "Passion", "Zhiyin"] },
  { make: "HiPhi", models: ["HiPhi X", "HiPhi Z", "HiPhi Y", "HiPhi A"] },
  { make: "Neta", models: ["Neta V", "Neta Aya", "Neta U", "Neta X", "Neta S", "Neta GT", "Neta L"] },
  { make: "ARCFOX", models: ["α-T", "α-S", "α-S5", "α-T5", "Kaola"] },
  { make: "Wuling", models: ["Hongguang Mini EV", "Bingo", "Bingo Plus", "Binguo", "Starlight", "Starlight S", "Air EV"] },
  { make: "Baojun", models: ["Yep", "Yep Plus", "Cloud", "KiWi EV", "RC-5", "RS-3"] },
  { make: "Omoda", models: ["Omoda 5", "Omoda E5", "Omoda C9", "Omoda 7"] },
  { make: "Jaecoo", models: ["Jaecoo 7", "Jaecoo 8", "Jaecoo 6"] },
  { make: "Jetour", models: ["Dashing", "X70", "X90", "Traveller T2", "Shanhai T2", "Shanhai L9"] },
  { make: "Exeed", models: ["RX", "VX", "TX", "TXL", "Exlantix ES", "Exlantix ET"] },
  { make: "iCAR", models: ["03", "03T", "V23"] },
  { make: "Radar", models: ["RD6", "Horizon"] },
  { make: "Rox Motor", models: ["01"] },
  { make: "Roewe", models: ["D7 EV", "D7 DMH", "RX5", "i5", "iMAX8 EV", "Marvel R"] },
  { make: "Rising Auto", models: ["F7", "R7"] },
  { make: "Maxus", models: ["Mifa 9", "Mifa 7", "T90 EV", "eDeliver 3", "eDeliver 9", "D90", "T60", "T60 Max", "T70", "eTerron 9", "D60", "G10"] },
  { make: "Hongqi", models: ["E-HS9", "EH7", "EHS7", "H5", "H9", "HQ9", "HS5"] },
  { make: "Dongfeng", models: ["Nammi 01", "Aeolus Yixuan", "M-Hero 917", "Rich 6", "Forthing T5 EVO"] },
  { make: "M-Hero", models: ["917", "M-Hunter"] },
  { make: "Seres", models: ["Seres 3", "Seres 5", "Seres 7"] },
  { make: "BAIC", models: ["BJ40", "BJ60", "BJ80", "EU5", "X35", "X55"] },
  { make: "JAC", models: ["JS4", "JS6", "JS8", "T6", "T8 Pro", "E30X", "e-J7"] },
  { make: "Foton", models: ["Tunland G7", "Tunland G9", "View", "Toano"] },
  { make: "Skyworth", models: ["EV6", "HT-i", "Skyhome"] },
  { make: "Aiways", models: ["U5", "U6"] },
  { make: "Dayun", models: ["Yuanzhi M1", "Yuehu", "Yuanhang Y6", "Yuanhang H8"] },
  { make: "Kandi", models: ["K27", "K23", "NeVCity"] },
  { make: "Farizon", models: ["SuperVAN", "Homtruck", "V6E"] },
  { make: "Hycan", models: ["Z03", "V09", "A06"] },
  { make: "Livan", models: ["Maple Leaf 60S", "Livan 7", "Livan 9"] },
  { make: "Geometry", models: ["Geometry A", "Geometry C", "Geometry E", "Panda Mini EV"] },

  // --- African & commercial makes common on Nigerian roads ---
  { make: "IVM", models: ["G5", "G40", "G80", "Fox", "Umu", "Connect", "Carrier"] },
  { make: "Nord", models: ["A3", "A5", "Tank", "Tusk", "Max"] },
  { make: "Kantanka", models: ["Omama", "Onantefo", "Amoanimaa", "Opoku", "Mensah"] },
  { make: "JMC", models: ["Vigus", "Yuhu", "Touring", "Carrying", "Boarding"] },
  { make: "FAW", models: ["Bestune T77", "Bestune B70", "Bestune T99", "Sirius S80", "Jiefang J6"] },
  { make: "Jinbei", models: ["Haise", "Grandview", "Granse", "F50"] },
  { make: "DFSK", models: ["Glory 500", "Glory 580", "Glory iX5", "C31", "K01"] },
  { make: "Haima", models: ["7X", "8S", "M3", "S5"] },
  { make: "King Long", models: ["Kingo", "Kaige", "Joylong", "XMQ6118"] },
  { make: "Hino", models: ["Dutro", "300 Series", "500 Series", "700 Series", "Ranger"] },
  { make: "Iveco", models: ["Daily", "Eurocargo", "S-Way", "Massif"] },

  // --- Western EV pure-plays, performance & luxury exotics ---
  { make: "Rimac", models: ["Nevera", "Concept_One"] },
  { make: "Fisker", models: ["Ocean", "Pear", "Alaska", "Ronin"] },
  { make: "Canoo", models: ["Lifestyle Vehicle", "Pickup Truck", "Multi-Purpose Delivery Vehicle"] },
  { make: "Karma", models: ["Revero", "Gyesera", "Kaveya", "GS-6"] },
  { make: "Apinis / Alpine", models: ["A110", "A290", "A390"] },
  { make: "Pininfarina", models: ["Battista", "B95"] },
  { make: "De Tomaso", models: ["Pantera", "Mangusta", "P72", "P900"] },
  { make: "Spyker", models: ["C8 Spyder", "C8 Laviolette", "C8 Aileron", "D8 Peking-to-Paris"] },
  { make: "Donkervoort", models: ["D8 GTO", "F22"] },
  { make: "Wiesmann", models: ["MF3", "MF4", "MF5", "Project Thunderball"] },
  { make: "Caterham", models: ["Seven 170", "Seven 360", "Seven 620", "Project V"] },
  { make: "Morgan", models: ["Plus Four", "Plus Six", "Super 3"] },
  { make: "TVR", models: ["Griffith", "Chimaera", "Cerbera", "Sagaris", "Tuscan"] },
  { make: "Noble", models: ["M12", "M400", "M600", "M500"] },
  { make: "Ariel", models: ["Atom", "Nomad", "Hipercar"] },
  { make: "BAC", models: ["Mono", "Mono R"] },
  { make: "KTM", models: ["X-Bow R", "X-Bow GT", "X-Bow GTX", "X-Bow GT2"] },
  { make: "Radical", models: ["SR1", "SR3", "SR8", "SR10", "RXC"] },
  { make: "Saleen", models: ["S7", "S1", "302 Mustang", "Sportruck"] },
  { make: "Hennessey", models: ["Venom GT", "Venom F5", "VelociRaptor", "Mammoth"] },
  { make: "Shelby", models: ["Cobra 427", "GT350", "GT500", "Super Snake"] },

  // --- Global, European, Asian & Australian OEMs ---
  { make: "DS Automobiles", models: ["DS 3", "DS 4", "DS 7", "DS 9"] },
  { make: "Abarth", models: ["595", "695", "500e", "600e", "124 Spider"] },
  { make: "Ineos", models: ["Grenadier", "Quartermaster", "Fusilier"] },
  { make: "Togg", models: ["T10X", "T10F"] },
  { make: "Mahindra", models: ["Scorpio-N", "XUV700", "XUV300", "XUV400 EV", "Thar", "Bolero"] },
  { make: "Force Motors", models: ["Gurkha", "Trax Cruiser", "Traveller"] },
  { make: "Proton", models: ["Saga", "Persona", "Iriz", "X50", "X70", "X90", "S70", "e.MAS 7"] },
  { make: "Perodua", models: ["Myvi", "Axia", "Bezza", "Ativa", "Alza", "Aruz"] },
  { make: "Holden", models: ["Commodore", "Caprice", "Monaro", "Calais", "Ute", "Colorado"] },
  { make: "HSV", models: ["Clubsport", "GTS", "Maloo", "Senator"] },
  { make: "Lada", models: ["Niva Legend", "Niva Travel", "Vesta", "Granta", "Largus"] },
  { make: "UAZ", models: ["Hunter", "Patriot", "Bukhanka (452)", "Pickup"] },
  { make: "GAZ", models: ["Volga", "Chaika", "Gazelle NEXT"] },

  // --- Classic, Legacy & Notable Brands ---
  { make: "Saturn", models: ["SL2", "SC2", "Ion", "Vue", "Sky", "Aura", "Outlook"] },
  { make: "Mercury", models: ["Grand Marquis", "Cougar", "Mountaineer", "Milan", "Marauder", "Sable"] },
  { make: "Plymouth", models: ["Barracuda", "Road Runner", "Fury", "Prowler", "Voyager", "Neon"] },
  { make: "Oldsmobile", models: ["Cutlass Supreme", "442", "Toronado", "88", "Alero", "Bravada", "Aurora"] },
  { make: "AMC", models: ["Javelin", "AMX", "Eagle", "Gremlin", "Pacer", "Rebel"] },
  { make: "Hummer", models: ["H1", "H2", "H3", "H3T"] },
  { make: "Geo", models: ["Metro", "Tracker", "Prizm", "Storm"] },
  { make: "Daewoo", models: ["Matiz", "Lanos", "Nubira", "Leganza", "Tico", "Cielo"] },
  { make: "Datsun", models: ["240Z", "280ZX", "510", "Bluebird", "GO", "GO+", "redi-GO"] },
  { make: "Rover", models: ["Mini", "25", "45", "75", "Streetwise", "SD1"] },
  { make: "Triumph", models: ["Spitfire", "TR3", "TR4", "TR6", "TR7", "Stag", "Herald"] },
  { make: "Austin", models: ["Mini", "Healey 3000", "Allegro", "Montego", "Maestro", "Metro"] },
  { make: "Morris", models: ["Minor", "Oxford", "Marina", "Ital", "Mini Minor"] },
  { make: "Talbot", models: ["Horizon", "Samba", "Solara", "Tagora", "Matra Rancho"] },
  { make: "Autobianchi", models: ["A112", "Y10", "Bianchina", "Primula"] },
  { make: "Maybach", models: ["57", "62", "Exelero"] },
  { make: "Brilliance", models: ["H530", "V3", "V5", "V6", "V7"] },
  { make: "Lifan", models: ["320", "520", "620", "X60", "X70"] },
  { make: "Soueast", models: ["DX3", "DX7", "DX8S", "A5"] },
  { make: "Zotye", models: ["T600", "SR9", "T700", "E200", "Z100"] },
];

// Colour options offered on the vehicle form.
export const carColors = [
  "Black", "White", "Pearl White", "Silver", "Gray", "Charcoal", "Graphite", "Blue", "Navy Blue", "Sky Blue", "Teal", "Turquoise",
  "Red", "Maroon", "Burgundy", "Orange", "Yellow", "Gold", "Champagne", "Bronze", "Copper", "Brown", "Beige", "Cream", "Tan",
  "Green", "Dark Green", "Olive", "Lime", "Purple", "Lavender", "Pink", "Magenta", "Other",
];

// Sorted make names for the "Make" dropdown, with a catch-all for anything not listed.
export const carMakes = [...carCatalog.map((c) => c.make)].sort((a, b) => a.localeCompare(b)).concat("Other");

export function getModelsForMake(make) {
  return carCatalog.find((c) => c.make === make)?.models || [];
}
